const ThemeColors = () => {
  const rootStyle = getComputedStyle(document.body);
  return {
    themeColor1: rootStyle.getPropertyValue("--theme-color-1").trim(),
    themeColor2: rootStyle.getPropertyValue("--theme-color-2").trim(),
    themeColor3: rootStyle.getPropertyValue("--theme-color-3").trim(),
    themeColor4: rootStyle.getPropertyValue("--theme-color-4").trim(),
    themeColor5: rootStyle.getPropertyValue("--theme-color-5").trim(),
    themeColor6: rootStyle.getPropertyValue("--theme-color-6").trim(),
    themeColor1_10: rootStyle.getPropertyValue("--theme-color-1-10").trim(),
    themeColor2_10: rootStyle.getPropertyValue("--theme-color-2-10").trim(),
    themeColor3_10: rootStyle.getPropertyValue("--theme-color-3-10").trim(),
    themeColor4_10: rootStyle.getPropertyValue("--theme-color-4-10").trim(),
    themeColor5_10: rootStyle.getPropertyValue("--theme-color-5-10").trim(),
    themeColor6_10: rootStyle.getPropertyValue("--theme-color-6-10").trim(),
    primaryColor: rootStyle.getPropertyValue("--primary-color").trim(),
    foregroundColor: rootStyle.getPropertyValue("--foreground-color").trim(),
    separatorColor: rootStyle.getPropertyValue("--separator-color").trim(),
  };
};

export const chartTooltip = {
  backgroundColor: ThemeColors().foregroundColor,
  titleColor: ThemeColors().foregroundColor === '#fff' ? '#000' : '#fff',
  borderColor: ThemeColors().separatorColor,
  borderWidth: 0.5,
  bodyColor: ThemeColors().foregroundColor === '#fff' ? '#000' : '#fff',
  bodySpacing: 10,
  padding: 15,
  cornerRadius: 0.15,
};

export const centerTextPlugin = {
  id: 'centerText',
  afterDatasetsUpdate() {},
  beforeDraw(chart) {
    const { width, height } = chart.chartArea;
    const { ctx } = chart;
    ctx.restore();

    let activeLabel = chart.data.labels[0];
    let activeValue = chart.data.datasets[0].data[0];
    let dataset = chart.data.datasets[0];
    
    // Get the meta data for calculating total
    const metaData = chart.getDatasetMeta(0);
    let total = metaData.total;

    let activePercentage = parseFloat(((activeValue / total) * 100).toFixed(1));
    activePercentage = chart.legend.legendItems[0].hidden
      ? 0
      : activePercentage;

    if (chart.pointAvailable) {
      activeLabel = chart.data.labels[chart.pointIndex];
      activeValue =
        chart.data.datasets[chart.pointDataIndex].data[chart.pointIndex];

      dataset = chart.data.datasets[chart.pointDataIndex];
      const pointMetaData = chart.getDatasetMeta(chart.pointDataIndex);
      total = pointMetaData.total;
      activePercentage = parseFloat(((activeValue / total) * 100).toFixed(1));
      activePercentage = chart.legend.legendItems[chart.pointIndex].hidden
        ? 0
        : activePercentage;
    }

    ctx.font = "36px Nunito, sans-serif";
    ctx.fillStyle = ThemeColors().primaryColor;
    ctx.textBaseline = "middle";

    const text = `${activePercentage}%`;
    const textX = Math.round((width - ctx.measureText(text).width) / 2) + chart.chartArea.left;
    const textY = chart.chartArea.top + height / 2;
    ctx.fillText(text, textX, textY);

    ctx.font = "14px Nunito, sans-serif";
    ctx.textBaseline = "middle";

    const text2 = activeLabel;
    const textX2 = Math.round((width - ctx.measureText(text2).width) / 2) + chart.chartArea.left;
    const textY2 = chart.chartArea.top + height / 2 - 30;
    ctx.fillText(text2, textX2, textY2);

    ctx.save();
  },
  // eslint-disable-next-line no-unused-vars
  beforeEvent(chart, args, options) {
    const event = args.event;
    const elements = chart.getElementsAtEventForMode(event.native, 'nearest', { intersect: true }, false);

    if (elements.length > 0) {
      const firstPoint = elements[0];
      // eslint-disable-next-line no-param-reassign
      chart.pointIndex = firstPoint.index;
      // eslint-disable-next-line no-param-reassign
      chart.pointDataIndex = firstPoint.datasetIndex;
      // eslint-disable-next-line no-param-reassign
      chart.pointAvailable = true;
    }
  },
};
